import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import apiClient from '../utils/apiClient';

const BillingContext = createContext({ subscription: null, loading: false, refresh: () => {} });
export const BillingProvider = ({ children }) => {
  const { user } = useAuth();
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) {
      setSubscription(null);
      return;
    }
    setLoading(true);
    try {
      const response = await apiClient.get('/billing/subscription');
      let next = response.data;
      if (next.quote_trial_enabled && next.quote_trial_flow_version === 'quote_v1' && next.quote_intro_completed) {
        next = (await apiClient.post('/billing/workspace-entry')).data;
      }
      setSubscription(next);
    } catch {
      setSubscription(null);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <BillingContext.Provider value={{ subscription, loading, refresh }}>
      {children}
    </BillingContext.Provider>
  );
};

export const useBilling = () => useContext(BillingContext);
